import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Spinner, Table, Modal, Form, InputGroup, ButtonGroup, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faEdit, faSearch, faBox, faStamp, faDollarSign, faCreditCard, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import SoftBadge from 'components/common/SoftBadge';
import ModalAsociarPlanFacturacion from './ModalAsociarPlanFacturacion';

const PlanesFacturacionMx = ({ idCliente, onPlanAgregado }) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [cargando, setCargando] = useState(false);
    const [planes, setPlanes] = useState([]);
    const [showModalAgregarTimbres, setShowModalAgregarTimbres] = useState(false);
    const [showModalAgregarPlan, setShowModalAgregarPlan] = useState(false);
    const [planesDisponibles, setPlanesDisponibles] = useState([]);
    const [busquedaPlan, setBusquedaPlan] = useState('');
    const [cargandoPlanesDisponibles, setCargandoPlanesDisponibles] = useState(false);
    const [creandoOrden, setCreandoOrden] = useState(false);
    const [rfcNuevoPlan, setRfcNuevoPlan] = useState('');
    const [guardandoPlan, setGuardandoPlan] = useState(false);
    const [idPlanFacturaMx, setIdPlanFacturaMx] = useState('');
    const [modoEdicion, setModoEdicion] = useState(false);
    const [planSeleccionado, setPlanSeleccionado] = useState(null);
    const [formaPagoSeleccionada, setFormaPagoSeleccionada] = useState(null);

    const [planAsociado, setPlanAsociado] = useState(null);
    const [ordenesSinPlan, setOrdenesSinPlan] = useState([]);
    const [cargandoOrdenesSinPlan, setCargandoOrdenesSinPlan] = useState(false);
    const [tabActivo, setTabActivo] = useState('planes');
    const [showModalAsociarPlan, setShowModalAsociarPlan] = useState(false);
    const [ordenSeleccionada, setOrdenSeleccionada] = useState(null);

    useEffect(() => {
        obtenerPlanesFacturacion();
        obtenerOrdenesSinPlan();
    }, []);

    const formatHeaderName = (key) => {
        const headerMap = {
            'idPlanFacturaMx': 'ID Plan',
            'vRfc': 'RFC',
            'iCantidades': 'Cantidades',
            'idOrden': 'Orden',
            'idOrdenDetalle': 'ID Detalle',
            'bIsPaid': 'Estado',
            'iCantidadTimbres': 'Timbres',
            'dTotal': 'Total',
        };

        return headerMap[key] || key
            .replace(/^[a-z]/, char => char.toUpperCase())
            .replaceAll(/([A-Z])/g, ' $1')
            .trim();
    };

    const obtenerPlanesFacturacion = async () => {
        setCargando(true);
        setPlanes([]);

        try {
            const response = await fetch('/api/cliente/getPlanesFacturacion', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idClienteAkasia: idCliente })
            });

            if (response.ok) {
                const data = await response.json();


                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    const table = detalles?.table2 || detalles?.Table2 || [];
                    setPlanes(Array.isArray(table) ? table : []);
                } else {
                    setPlanes(Array.isArray(data) ? data : data?.table1 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Hubo un problema al obtener planes de facturación: ' + error.message);
        } finally {
            setCargando(false);
        }
    };

    const handleAbrirModalAgregarPlan = () => {
        setShowModalAgregarPlan(true);
        setRfcNuevoPlan('');
        setIdPlanFacturaMx('');
        setModoEdicion(false);
    };

    const handleAbrirModalAgregarTimbres = async (plan) => {
        setShowModalAgregarTimbres(true);
        setPlanAsociado(plan);
        await obtenerPlanesDisponibles();
    };

    const handleEditarPlan = (plan) => {
        setShowModalAgregarPlan(true);
        setRfcNuevoPlan(plan.vRfc || '');
        setIdPlanFacturaMx(plan.idPlanFacturaMx || '');
        setModoEdicion(true);
    };

    const handleCerrarModalAgregarPlan = () => {
        setShowModalAgregarPlan(false);
        setRfcNuevoPlan('');
        setIdPlanFacturaMx('');
        setModoEdicion(false);
    };

    const handleCerrarModalAgregarTimbres = () => {
        setShowModalAgregarTimbres(false);
        setBusquedaPlan('');
        setPlanSeleccionado(null);
        setFormaPagoSeleccionada(null);
        setPlanAsociado(null);
    };

    const handleGuardarNuevoPlan = async () => {
        if (!rfcNuevoPlan.trim()) {
            showErrorToast('Por favor ingrese un RFC válido');
            return;
        }

        setGuardandoPlan(true);
        try {
            const response = await fetch('/api/cliente/WSFacturacionMXAuthInsertUpdate', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idClienteAkasia: idCliente,
                    rfc: rfcNuevoPlan.trim(),
                    idPlanFacturaMx: idPlanFacturaMx || null,
                    bIsActive: true
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(modoEdicion ? 'Plan actualizado exitosamente' : 'Plan de facturación agregado exitosamente');
                    handleCerrarModalAgregarPlan();
                    obtenerPlanesFacturacion();
                    if (onPlanAgregado) onPlanAgregado();
                } else {
                    showErrorToast(data.vMessage || 'Error al guardar el plan');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al guardar el plan: ' + error.message);
        } finally {
            setGuardandoPlan(false);
        }
    };

    const obtenerPlanesDisponibles = async () => {
        setCargandoPlanesDisponibles(true);
        try {
            const response = await fetch('/api/cliente/getPlanesDisponiblesFacturacionMx', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta completa de getPlanesDisponiblesFacturacionMx:', data);

                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    console.log('Detalles parseados:', detalles);
                    const table = detalles?.table2 || detalles?.Table2 || [];
                    console.log('Table2 extraída:', table);
                    setPlanesDisponibles(Array.isArray(table) ? table : []);
                } else {
                    console.log('Usando data directamente o data.table2');
                    setPlanesDisponibles(Array.isArray(data) ? data : data?.table2 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al obtener planes disponibles: ' + error.message);
        } finally {
            setCargandoPlanesDisponibles(false);
        }
    };

    console.log('Planes disponibles para agregar timbres:', planesDisponibles);

    const obtenerOrdenesSinPlan = async () => {
        setCargandoOrdenesSinPlan(true);
        setOrdenesSinPlan([]);

        try {
            const response = await fetch(`/api/orden/GetOrdenSinPlanFactura?idClienteAkasia=${idCliente}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta de GetOrdenSinPlanFactura:', data);

                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    const table = detalles?.table2 || detalles?.Table2 || [];
                    setOrdenesSinPlan(Array.isArray(table) ? table : []);
                } else {
                    setOrdenesSinPlan(Array.isArray(data) ? data : data?.table2 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al obtener órdenes sin plan: ' + error.message);
        } finally {
            setCargandoOrdenesSinPlan(false);
        }
    };

    const obtenerFormasPago = async () => {
        try {
            const response = await fetch('/api/cliente/getFormasPago', {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + token }
            });
            if (response.ok) {
                const data = await response.json();
                let lista = [];
                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    lista = detalles?.table2 || detalles?.Table2 || [];
                } else {
                    lista = Array.isArray(data) ? data : data?.table2 || [];
                }
                const forma = lista.find(f => f.vClave === '99') || null;
                setFormaPagoSeleccionada(forma);
            } else if (response.status === 401) {
                setToken(null);
                location.href = '';
            }
        } catch { /* silencioso */ }
    };

    const handleSeleccionarPlan = async (plan) => {
        setPlanSeleccionado(plan);
        await obtenerFormasPago();
    };

    const handleVolverALista = () => {
        setPlanSeleccionado(null);
        setFormaPagoSeleccionada(null);
    };

    const handleConfirmarOrden = async () => {
        setCreandoOrden(true);
        try {
            const body = {
                idClienteAkasia: idCliente,
                vUUIDProducto: planSeleccionado.vUUIDProducto,
                idCatFormaPago: formaPagoSeleccionada?.idCatFormaPago ?? 99
            };

            // Solo agregar idPlanFacturaMx si la orden viene desde un plan de facturación
            if (planAsociado?.idPlanFacturaMx) {
                body.idPlanFacturaMx = planAsociado.idPlanFacturaMx;
            }

            const response = await fetch('/api/orden/generarOrdenFacturacionMx', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast('Orden creada exitosamente');
                    handleCerrarModalAgregarTimbres();
                    obtenerPlanesFacturacion();
                    if (onPlanAgregado) onPlanAgregado();
                    try {
                        const detalles = JSON.parse(data.detalles);
                        const idOrden = Array.isArray(detalles) ? detalles[0]?.idOrden : detalles?.idOrden;
                        if (idOrden) window.open(`/ordenes/detalle/${idOrden}`, '_blank');
                    } catch { /* sin id de orden */ }
                } else {
                    showErrorToast(data.vMessage || 'Error al crear la orden');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al crear la orden: ' + error.message);
        } finally {
            setCreandoOrden(false);
        }
    };

    const handleAbrirModalAsociarPlan = (orden) => {
        setOrdenSeleccionada(orden);
        setShowModalAsociarPlan(true);
    };

    const handleCerrarModalAsociarPlan = () => {
        setShowModalAsociarPlan(false);
        setOrdenSeleccionada(null);
    };

    const handlePlanAsociado = async () => {
        await obtenerOrdenesSinPlan();
        await obtenerPlanesFacturacion();
    };

    const planesFiltrados = planesDisponibles.filter(plan =>
        plan.vNombreProducto?.toLowerCase().includes(busquedaPlan.toLowerCase()) ||
        plan.iCantidadTimbresMx?.toString().includes(busquedaPlan)
    );

    const renderOrdenesSinPlan = () => {
        if (cargandoOrdenesSinPlan) {
            return (
                <div className="d-flex align-items-center">
                    <Spinner animation="border" size="sm" className="me-2" />
                    Cargando órdenes...
                </div>
            );
        }

        if (ordenesSinPlan.length === 0) {
            return (
                <p className="mb-0 text-muted">
                    No hay órdenes pagadas sin plan asociado.
                </p>
            );
        }

        return (
            <div className="ordenes-table-wrapper">
                <Table responsive className="ordenes-table">
                    <thead>
                        <tr>
                            {Object.keys(ordenesSinPlan[0]).filter(key => key !== 'idOrdenDetalle').map((key) => (
                                <th key={key}>
                                    {formatHeaderName(key)}
                                </th>
                            ))}
                            <th style={{ width: '200px' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ordenesSinPlan.map((orden, index) => (
                            <tr key={orden.idOrden || index}>
                                {Object.keys(ordenesSinPlan[0]).filter(key => key !== 'idOrdenDetalle').map((key) => {
                                    if (key === 'idOrden') {
                                        return (
                                            <td key={key}>
                                                <span
                                                    className="text-primary fw-semibold"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => window.open(`/ordenes/detalle/${orden.idOrden}`, '_blank')}
                                                >
                                                    #{orden.idOrden}
                                                </span>
                                            </td>
                                        );
                                    }
                                    if (key === 'vRfc') {
                                        return (
                                            <td key={key}>
                                                {orden[key] ? (
                                                    String(orden[key])
                                                ) : (
                                                    <SoftBadge bg="warning">No Asociado</SoftBadge>
                                                )}
                                            </td>
                                        );
                                    }
                                    if (key === 'bIsPaid') {
                                        return (
                                            <td key={key}>
                                                <span className={`badge badge-soft-${orden[key] ? 'success' : 'warning'}`}>
                                                    {orden[key] ? 'Pagada' : 'Pendiente'}
                                                </span>
                                            </td>
                                        );
                                    }
                                    if (key === 'dTotal') {
                                        return (
                                            <td key={key}>
                                                <span className="badge badge-soft-info">
                                                    ${orden[key]}
                                                </span>
                                            </td>
                                        );
                                    }
                                    if (key === 'iCantidadTimbres') {
                                        return (
                                            <td key={key}>
                                                <span className="badge badge-soft-primary">
                                                    {orden[key]}
                                                </span>
                                            </td>
                                        );
                                    }
                                    return (
                                        <td key={key}>
                                            {String(orden[key] ?? '')}
                                        </td>
                                    );
                                })}
                                <td>
                                    {orden.vRfc ? (
                                        <Button
                                            variant="info"
                                            size="sm"
                                            onClick={() => window.open(`/ordenes/detalle/${orden.idOrden}`, '_blank')}
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            Ver Detalles
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="primary"
                                            size="sm"
                                            onClick={() => handleAbrirModalAsociarPlan(orden)}
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            <FontAwesomeIcon icon={faPlusCircle} className="me-1" />
                                            Asociar a Plan
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };

    const renderContent = () => {
        if (cargando) {
            return (
                <div className="d-flex align-items-center">
                    <Spinner animation="border" size="sm" className="me-2" />
                    Cargando planes...
                </div>
            );
        }

        if (planes.length === 0) {
            return <p className="mb-0 text-muted">No se encontraron planes.</p>;
        }

        return (
            <div className="planes-table-wrapper">
                <Table responsive className="planes-table">
                    <thead>
                        <tr>
                            {Object.keys(planes[0]).map((key) => (
                                <th key={key}>
                                    {formatHeaderName(key)}
                                </th>
                            ))}
                            <th style={{ width: '150px' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {planes.map((plan) => (
                            <tr key={JSON.stringify(plan)}>
                                {Object.keys(planes[0]).map((key) => (
                                    <td key={key}>
                                        {String(plan[key] ?? '')}
                                    </td>
                                ))}
                                <td>
                                    <ButtonGroup className="w-100" size="sm">
                                        <Button
                                            variant="success"
                                            onClick={() => handleAbrirModalAgregarTimbres(plan)}
                                            title="Agregar Timbres"
                                            style={{ flex: 1, whiteSpace: 'nowrap' }}
                                        >
                                            <FontAwesomeIcon icon={faPlusCircle} className="me-1" />
                                            Timbres
                                        </Button>
                                        <Button
                                            variant="outline-primary"
                                            onClick={() => handleEditarPlan(plan)}
                                            title="Editar Plan"
                                            style={{ minWidth: '45px' }}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </Button>
                                    </ButtonGroup>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };

    return (
        <>
            <Card className="mt-3">
                <Card.Header className="border-bottom border-200">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Planes de facturación Mx</h5>
                        {tabActivo === 'planes' && (
                            <div className="d-flex gap-2">
                                <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => handleAbrirModalAgregarTimbres(null)}
                                >
                                    Agregar Timbres
                                </Button>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={handleAbrirModalAgregarPlan}
                                    disabled={cargando}
                                >
                                    Agregar Plan de Facturación
                                </Button>
                            </div>
                        )}

                    </div>
                    <Nav variant="tabs" activeKey={tabActivo} onSelect={(k) => setTabActivo(k)}>
                        <Nav.Item>
                            <Nav.Link eventKey="planes">Planes de Facturación</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="ordenes">Órdenes Planes de Facturación</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Card.Header>
                <Card.Body style={{ maxHeight: '350px', overflowY: 'auto' }}>
                    {tabActivo === 'planes' ? renderContent() : renderOrdenesSinPlan()}
                </Card.Body>
            </Card>

            <Modal show={showModalAgregarPlan} centered onHide={handleCerrarModalAgregarPlan}>
                <Modal.Header closeButton>
                    <Modal.Title>{modoEdicion ? 'Editar Plan de Facturación' : 'Agregar Plan de Facturación'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>RFC</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ingrese el RFC..."
                            value={rfcNuevoPlan}
                            onChange={(e) => setRfcNuevoPlan(e.target.value.toUpperCase())}
                            onKeyDown={(e) => { if (e.key === 'Enter' && rfcNuevoPlan.trim() && !guardandoPlan) handleGuardarNuevoPlan(); }}
                            maxLength={13}
                        />
                        <Form.Text className="text-muted">
                            Ingrese el RFC al que se asociará el plan de facturación
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCerrarModalAgregarPlan}>
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleGuardarNuevoPlan}
                        disabled={guardandoPlan || !rfcNuevoPlan.trim()}
                    >
                        {guardandoPlan ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Guardando...
                            </>
                        ) : (
                            'Guardar'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalAgregarTimbres} centered onHide={handleCerrarModalAgregarTimbres} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{planSeleccionado ? 'Confirmar Orden' : 'Agregar Timbres'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!planSeleccionado ? (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>Buscar plan de facturación</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar por nombre o descripción..."
                                        value={busquedaPlan}
                                        onChange={(e) => setBusquedaPlan(e.target.value)}
                                    />
                                </InputGroup>
                            </Form.Group>

                            {cargandoPlanesDisponibles ? (
                                <div className="text-center py-4">
                                    <Spinner animation="border" />
                                    <p className="mt-2">Cargando planes disponibles...</p>
                                </div>
                            ) : planesFiltrados.length === 0 ? (
                                <div className="text-center py-4 text-muted">
                                    {busquedaPlan ? 'No se encontraron planes que coincidan con la búsqueda' : 'No hay planes disponibles'}
                                </div>
                            ) : (
                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <Table hover responsive>
                                        <thead>
                                            <tr>
                                                <th>Producto</th>
                                                <th>Cantidad Timbres</th>
                                                <th>Precio</th>
                                                <th>Moneda</th>
                                                <th style={{ width: '120px' }}>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {planesFiltrados.map((plan, index) => (
                                                <tr key={plan.vUUIDProducto || index}>
                                                    <td>{plan.vNombreProducto || 'N/A'}</td>
                                                    <td>{plan.iCantidadTimbresMx || 'N/A'}</td>
                                                    <td>{plan.dTotal ? '$' + plan.dTotal : 'N/A'}</td>
                                                    <td>{plan.vMoneda || 'N/A'}</td>
                                                    <td>
                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            onClick={() => handleSeleccionarPlan(plan)}
                                                            className="w-100"
                                                        >
                                                            Seleccionar
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="mb-3 border rounded overflow-hidden">
                            <div className="bg-success bg-opacity-10 px-3 py-2 border-bottom d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-2">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                                    <span className="fw-semibold text-success">Resumen de la orden</span>
                                </div>
                                <SoftBadge bg="secondary" className="d-flex align-items-center gap-1">
                                    <FontAwesomeIcon icon={faCreditCard} />
                                    {formaPagoSeleccionada ? formaPagoSeleccionada.vDescripcionFormaPago : 'Por definir'}
                                </SoftBadge>
                            </div>
                            <div className="p-3">
                                <div className="d-flex align-items-start gap-3 mb-3 pb-3 border-bottom">
                                    <div className="rounded bg-primary bg-opacity-10 p-2 d-flex align-items-center justify-content-center" style={{ minWidth: '40px', height: '40px' }}>
                                        <FontAwesomeIcon icon={faBox} className="text-primary" />
                                    </div>
                                    <div>
                                        <div className="text-muted small">Producto</div>
                                        <div className="fw-bold">{planSeleccionado.vNombreProducto}</div>
                                    </div>
                                </div>
                                <div className="row g-3">
                                    <div className="col-6">
                                        <div className="d-flex align-items-center gap-2">
                                            <FontAwesomeIcon icon={faStamp} className="text-info" />
                                            <div>
                                                <div className="text-muted small">Timbres incluidos</div>
                                                <div className="fw-bold fs-5 text-info">{planSeleccionado.iCantidadTimbresMx}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="d-flex align-items-center gap-2">
                                            <FontAwesomeIcon icon={faDollarSign} className="text-success" />
                                            <div>
                                                <div className="text-muted small">Total a pagar</div>
                                                <div className="fw-bold fs-5 text-success">${planSeleccionado.dTotal} <span className="fs-3">{planSeleccionado.vMoneda}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {!planSeleccionado ? (
                        <Button variant="secondary" onClick={handleCerrarModalAgregarTimbres}>
                            Cancelar
                        </Button>
                    ) : (
                        <>
                            <Button variant="secondary" onClick={handleVolverALista}>
                                Volver
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleConfirmarOrden}
                                disabled={creandoOrden || !formaPagoSeleccionada}
                            >
                                {creandoOrden ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Procesando...
                                    </>
                                ) : (
                                    'Confirmar Orden'
                                )}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            <ModalAsociarPlanFacturacion
                show={showModalAsociarPlan}
                onHide={handleCerrarModalAsociarPlan}
                ordenSeleccionada={ordenSeleccionada}
                onPlanAsociado={handlePlanAsociado}
                idCliente={idCliente}
            />

        </>
    );
};

PlanesFacturacionMx.propTypes = {
    idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onPlanAgregado: PropTypes.func
};

export default PlanesFacturacionMx;
